import type React from 'react'

type Props = {
  className?: string
  size?: number
  onClick?: () => void
}

const IconChevronDown: React.FC<Props & React.SVGProps<SVGSVGElement>> = ({
  className,
  size = 16,
  ...props
}) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.0938 7.52734L8.49805 12.8887C8.32227 13.0352 8.14648 13.0938 8 13.0938C7.82422 13.0938 7.64844 13.0352 7.50195 12.918L1.87695 7.52734C1.58398 7.26367 1.58398 6.79492 1.84766 6.53125C2.11133 6.23828 2.58008 6.23828 2.84375 6.50195L8 11.4238L13.127 6.50195C13.3906 6.23828 13.8594 6.23828 14.123 6.53125C14.3867 6.79492 14.3867 7.26367 14.0938 7.52734Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default IconChevronDown
